/* DO NOT EDIT!
   This file is generated from: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abportal/client/localeProperties/abportal_en.properties
   To regenerate after edits to the above file, invoke the module's package.json task: locale:regen:maven
   Also helpful: https://confluence.abinitio.com/display/FED/Localization+for+Developers
*/// eslint-disable
import{AbWebServices}from"abweb/service/AbWebServices";/**
 * <pre>
 * abPortalHome.abPersonaSplashScreen.allFeaturesPersona=Continue without selecting a persona
 * </pre>
 */export function abPortalHome_abPersonaSplashScreen_allFeaturesPersona(){return AbWebServices.i18n.getMessage("abportal","abPortalHome.abPersonaSplashScreen.allFeaturesPersona");}/**
 * <pre>
 * abPortalHome.abPersonaSplashScreen.title=Choose a Persona
 * </pre>
 */export function abPortalHome_abPersonaSplashScreen_title(){return AbWebServices.i18n.getMessage("abportal","abPortalHome.abPersonaSplashScreen.title");}/**
 * <pre>
 * abPortalHome.myActivity=My Activity
 * </pre>
 */export function abPortalHome_myActivity(){return AbWebServices.i18n.getMessage("abportal","abPortalHome.myActivity");}/**
 * <pre>
 * abPortalHome.myActivity.recentlyViewed.view=View
 * </pre>
 */export function abPortalHome_myActivity_recentlyViewed_view(){return AbWebServices.i18n.getMessage("abportal","abPortalHome.myActivity.recentlyViewed.view");}/**
 * <pre>
 * abPortalHome.myActivity.recentlyViewed.viewType=View Type
 * </pre>
 */export function abPortalHome_myActivity_recentlyViewed_viewType(){return AbWebServices.i18n.getMessage("abportal","abPortalHome.myActivity.recentlyViewed.viewType");}/**
 * <pre>
 * abPortalHome.outstandingTasks=Outstanding Tasks
 * </pre>
 */export function abPortalHome_outstandingTasks(){return AbWebServices.i18n.getMessage("abportal","abPortalHome.outstandingTasks");}/**
 * <pre>
 * abPortalHome.recentlyViewed=Recently Viewed
 * </pre>
 */export function abPortalHome_recentlyViewed(){return AbWebServices.i18n.getMessage("abportal","abPortalHome.recentlyViewed");}/**
 * <pre>
 * abportal.contactUs=Contact us
 * </pre>
 */export function abportal_contactUs(){return AbWebServices.i18n.getMessage("abportal","abportal.contactUs");}/**
 * <pre>
 * abportal.haveQuestions=Have questions?
 * </pre>
 */export function abportal_haveQuestions(){return AbWebServices.i18n.getMessage("abportal","abportal.haveQuestions");}/**
 * <pre>
 * administration.logAdministration.pageTitle=Logging
 * </pre>
 */export function administration_logAdministration_pageTitle(){return AbWebServices.i18n.getMessage("abportal","administration.logAdministration.pageTitle");}/**
 * <pre>
 * administration.logLevels.pageTitle=Log Levels
 * </pre>
 */export function administration_logLevels_pageTitle(){return AbWebServices.i18n.getMessage("abportal","administration.logLevels.pageTitle");}/**
 * <pre>
 * administration.logs.pageTitle=Logs
 * </pre>
 */export function administration_logs_pageTitle(){return AbWebServices.i18n.getMessage("abportal","administration.logs.pageTitle");}/**
 * <pre>
 * application.controlCenter.description=Manage your Ab Initio jobs
 * </pre>
 */export function application_controlCenter_description(){return AbWebServices.i18n.getMessage("abportal","application.controlCenter.description");}/**
 * <pre>
 * application.expressIt.description=Develop Ab Initio graph-based applications
 * </pre>
 */export function application_expressIt_description(){return AbWebServices.i18n.getMessage("abportal","application.expressIt.description");}/**
 * <pre>
 * application.queryIt.description=Administer your Query>It sandboxes
 * </pre>
 */export function application_queryIt_description(){return AbWebServices.i18n.getMessage("abportal","application.queryIt.description");}/**
 * <pre>
 * application.trw.description=Manage your EME Technical Repository
 * </pre>
 */export function application_trw_description(){return AbWebServices.i18n.getMessage("abportal","application.trw.description");}/**
 * <pre>
 * dataCatalogServices.pageTitle={0} - Data Catalog Services
 * </pre>
 */export function dataCatalogServices_pageTitle(arg0){return AbWebServices.i18n.getMessage("abportal","dataCatalogServices.pageTitle",arg0);}/**
 * <pre>
 * dataCatalogServices.status=Status
 * </pre>
 */export function dataCatalogServices_status(){return AbWebServices.i18n.getMessage("abportal","dataCatalogServices.status");}/**
 * <pre>
 * dataCatalogServices.title=Data Catalog Services
 * </pre>
 */export function dataCatalogServices_title(){return AbWebServices.i18n.getMessage("abportal","dataCatalogServices.title");}/**
 * <pre>
 * manageJobs.pageTitle=Manage Jobs Homepage
 * </pre>
 */export function manageJobs_pageTitle(){return AbWebServices.i18n.getMessage("abportal","manageJobs.pageTitle");}/**
 * <pre>
 * manageJobs.title=Manage Jobs
 * </pre>
 */export function manageJobs_title(){return AbWebServices.i18n.getMessage("abportal","manageJobs.title");}/**
 * <pre>
 * productCapabilities.authGateway.assignRoles=Manage groups and roles
 * </pre>
 */export function productCapabilities_authGateway_assignRoles(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.authGateway.assignRoles");}/**
 * <pre>
 * productCapabilities.authGateway.manageUsers=Manage users
 * </pre>
 */export function productCapabilities_authGateway_manageUsers(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.authGateway.manageUsers");}/**
 * <pre>
 * productCapabilities.capabilities=Capabilities
 * </pre>
 */export function productCapabilities_capabilities(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.capabilities");}/**
 * <pre>
 * productCapabilities.controlCenter.monitor=Monitor running jobs
 * </pre>
 */export function productCapabilities_controlCenter_monitor(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.controlCenter.monitor");}/**
 * <pre>
 * productCapabilities.controlCenter.schedule=Schedule jobs
 * </pre>
 */export function productCapabilities_controlCenter_schedule(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.controlCenter.schedule");}/**
 * <pre>
 * productCapabilities.expressIt.appConfig=Configure business applications
 * </pre>
 */export function productCapabilities_expressIt_appConfig(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.expressIt.appConfig");}/**
 * <pre>
 * productCapabilities.expressIt.ruleset=Specify business rules
 * </pre>
 */export function productCapabilities_expressIt_ruleset(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.expressIt.ruleset");}/**
 * <pre>
 * productCapabilities.expressIt.transformData=Transform data
 * </pre>
 */export function productCapabilities_expressIt_transformData(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.expressIt.transformData");}/**
 * <pre>
 * productCapabilities.metadataPortal.addBusinessTerm=Add business terms
 * </pre>
 */export function productCapabilities_metadataPortal_addBusinessTerm(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.addBusinessTerm");}/**
 * <pre>
 * productCapabilities.metadataPortal.addDQControls=Add data quality controls
 * </pre>
 */export function productCapabilities_metadataPortal_addDQControls(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.addDQControls");}/**
 * <pre>
 * productCapabilities.metadataPortal.addDatasets=Add datasets
 * </pre>
 */export function productCapabilities_metadataPortal_addDatasets(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.addDatasets");}/**
 * <pre>
 * productCapabilities.metadataPortal.exploreTechnicalAssets=Explore technical assets
 * </pre>
 */export function productCapabilities_metadataPortal_exploreTechnicalAssets(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.exploreTechnicalAssets");}/**
 * <pre>
 * productCapabilities.metadataPortal.findAndExplore=Find and explore data
 * </pre>
 */export function productCapabilities_metadataPortal_findAndExplore(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.findAndExplore");}/**
 * <pre>
 * productCapabilities.metadataPortal.getHelp=Metadata&nbsp;Portal Help
 * </pre>
 */export function productCapabilities_metadataPortal_getHelp(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.getHelp");}/**
 * <pre>
 * productCapabilities.metadataPortal.loadToDataLake=Load data into a data lake
 * </pre>
 */export function productCapabilities_metadataPortal_loadToDataLake(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.loadToDataLake");}/**
 * <pre>
 * productCapabilities.metadataPortal.mask=Mask sensitive data at scale
 * </pre>
 */export function productCapabilities_metadataPortal_mask(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.mask");}/**
 * <pre>
 * productCapabilities.metadataPortal.promote=Promote metadata
 * </pre>
 */export function productCapabilities_metadataPortal_promote(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.promote");}/**
 * <pre>
 * productCapabilities.metadataPortal.semanticDiscovery=Enrich data with Semantic&nbsp;Discovery
 * </pre>
 */export function productCapabilities_metadataPortal_semanticDiscovery(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.semanticDiscovery");}/**
 * <pre>
 * productCapabilities.metadataPortal.tag=Create version tags
 * </pre>
 */export function productCapabilities_metadataPortal_tag(){return AbWebServices.i18n.getMessage("abportal","productCapabilities.metadataPortal.tag");}/**
 * <pre>
 * trw.noActiveReview=No Active Review
 * </pre>
 */export function trw_noActiveReview(){return AbWebServices.i18n.getMessage("abportal","trw.noActiveReview");}/**
 * <pre>
 * trw.noRevisionsAvailable=No revisions available
 * </pre>
 */export function trw_noRevisionsAvailable(){return AbWebServices.i18n.getMessage("abportal","trw.noRevisionsAvailable");}/**
 * <pre>
 * trw.noUserReviewsAvailable=No user reviews available
 * </pre>
 */export function trw_noUserReviewsAvailable(){return AbWebServices.i18n.getMessage("abportal","trw.noUserReviewsAvailable");}/**
 * <pre>
 * # {0} is the user review name
 * trw.userReviewName=User Review Name: {0}
 * </pre>
 */export function trw_userReviewName(arg0){return AbWebServices.i18n.getMessage("abportal","trw.userReviewName",arg0);}
//# sourceMappingURL=AbPortalResources.js.map
